// generated by srcset-codegen
import src from "./trash.svg";

const width = 18;
const height = 20;
export default { src, width, height };
